import React from 'react';
import { Box } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize, fontWeight } from 'styled-system';
import { Link } from 'react-router-dom';
import theme from 'styled-theming';

const linkColor = theme('mode', {
  light: (props) => props.theme.colors.mediumPurple,
  dark: (props) => props.theme.colors.white,
});

const NavHeaderItem = styled(Link)`
  ${space}
  ${fontSize}
  ${fontWeight}
  display: flex;
  align-items: center;
  color: ${linkColor};
  text-decoration: none;
  user-select: none;
  flex-shrink: 0;
`;

const Label = styled(Box)`
  ${fontSize}
  ${fontWeight}
`;

function NavHeader(props) {
  const { label, Icon, to } = props;

  return (
    <NavHeaderItem data-testid="nav-header" to={to}>
      <Box height={24} width={24} mr={2}>
        {Icon ? <Icon title={label} alt={label} /> : null}
      </Box>
      <Label fontSize={1} fontWeight={400}>
        {label}
      </Label>
    </NavHeaderItem>
  );
}

NavHeader.defaultProps = {
  to: '',
  Icon: undefined,
  label: undefined,
};

NavHeader.propTypes = {
  to: PropTypes.string,
  Icon: PropTypes.object,
  label: PropTypes.string,
};

export default NavHeader;
